import {trans} from '@frontend/helpers'
import {useIsDesktopScreen} from '@frontend/hooks/useIsDesktopScreen'
import {PromoCards} from '@frontend/modules/layout/promo_cards/PromoCards'
import {RecentlyViewedAds} from '@frontend/modules/public/ads/components/list/RecentlyViewedAds'

// Правая панель для главной страницы.
// Отображает недавно просмотренные объявления и промо карточки.
export function HomePageRightPanel() {

    const isDesktop = useIsDesktopScreen()

    if (!isDesktop) {
        return null
    }

    return (
        <div
            id="offered-items-sidebar-right"
            className="ms-4 flex-shrink-0"
        >
            <RecentlyViewedAds className="pt-2" />
            <div className="promo-cards-block-wrapper">
                <div className="mt-3 mt-md-0 mt-xl-3 fw-500 fs-5">
                    {trans().ads.list.features}:
                </div>
                <PromoCards
                    className="mt-3"
                    utmSource="home_page_side_panel"
                />
            </div>
        </div>
    )
}
